import { render, staticRenderFns } from "./SpecialtyForm.vue?vue&type=template&id=6a3ad12a&"
import script from "./SpecialtyForm.vue?vue&type=script&lang=js&"
export * from "./SpecialtyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports